import { render, staticRenderFns } from "./activityRegistration.vue?vue&type=template&id=aeea8eb0"
import script from "./activityRegistration.vue?vue&type=script&lang=js"
export * from "./activityRegistration.vue?vue&type=script&lang=js"
import style0 from "./activityRegistration.vue?vue&type=style&index=0&id=aeea8eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports